import { getStudentDisplayName } from "../utils/studentUtils";

const StudentDetailPanel = ({ student, isParent = false }) => (
  <section className="student-detail-panel">
    <div>
      <p className="eyebrow">{isParent ? "Kid profile" : "Student profile"}</p>
      <h1>{getStudentDisplayName(student)}</h1>
      <p>{isParent ? "Kid Code" : "Student Code"}: {student.studentCode || "Not available"}</p>
    </div>
    <dl className="student-detail-list">
      <div>
        <dt>Credential Email</dt>
        <dd>{student.email || "Not set"}</dd>
      </div>
      <div>
        <dt>Grade</dt>
        <dd>{student.grade || "Not set"}</dd>
      </div>
      <div>
        <dt>Age</dt>
        <dd>{student.age ?? "Not set"}</dd>
      </div>
      <div>
        <dt>Status</dt>
        <dd>{student.active ? "Active" : "Disabled"}</dd>
      </div>
    </dl>
  </section>
);

export default StudentDetailPanel;
